import { render, staticRenderFns } from "./EditBotProfile.vue?vue&type=template&id=07511684&"
import script from "./EditBotProfile.vue?vue&type=script&lang=js&"
export * from "./EditBotProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports